import React from "react";
import { BLOG_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import BlogList from "../../components/BlogList/BlogList";
import BlogPagination from "../../components/BlogPagination/BlogPagination";
import LayoutBlog from "../../layouts/LayoutBlog";

const Blog = () => {
  usePageSeo(BLOG_SEO);

  return (
    <LayoutBlog pageTitle={"Blog & Article"} item={"Blog"}>
      <BlogList />
      <BlogPagination />
    </LayoutBlog>
  );
};

export default Blog;
